import React,{useState,useEffect} from 'react'
import '../styles/friendPart.css'
import {useSelector,useDispatch} from 'react-redux'
import {EmptyMassage} from './comps'
import * as actions from '../data/follow_data'
import * as normalActions from '../store/actions'
import {useNavigate} from 'react-router-dom';
import * as authAction from '../store/authAction'
 import { BiSearch} from 'react-icons/bi';
// import translations,{Change} from '../translations/translate'
import { MdOutlineVerified} from 'react-icons/md';
import { IoIosArrowBack } from "react-icons/io";
import StoryViewer from './storyViewer'
import { hasStory } from '../utils/story'
import UserAvatar from './userAvatar'


const LeaderPart = props =>{
const [isload,setLoad] =useState(false);
const [storyUser, setStoryUser] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

useEffect(async()=>{
    const userData = localStorage.getItem('userdata');
      if(userData){
    const {id,pid} = await JSON.parse(userData);
    await dispatch(authAction.auth(id,pid));}

  const getData3 = async () =>{
    setLoad(true);
  await dispatch(actions.get_following());
setLoad(false);
}
  getData3()
},[dispatch])
const translations = useSelector(state => state.lang_reduse.lang);
  const list = useSelector(state => state.followReduse.followersList);
  return(

    <div className={props.page?'FriendPart full': 'FriendPart small'}>
    <StoryViewer
      open={Boolean(storyUser)}
      onClose={() => setStoryUser(null)}
      media={storyUser?.story}
      name={storyUser?.email || storyUser?.name}
      photo={storyUser?.photo}
    />
     <div className='lfPartHeader'>
      <p onClick={()=>{navigate(`/profile`)}}><IoIosArrowBack /></p>
      <div className='lfPartTitles'>
        <h1>{translations.followers}</h1>
        <h2>{list.length}</h2>
      </div>
      <p onClick={()=>{navigate('/search')}}><BiSearch /></p>
     </div>
  <EmptyMassage loading={!!isload && (!list || list.length === 0)} color="gray" list={list} title={translations.thereisnofollowers} />
<div className='colorAroundLead'>
{list.map((item,index)=>{return(
    <div key={index} className="window2">
      <UserAvatar
        src={item.photo}
        name={item.email}
        alt='frindPhoto'
        className={hasStory(item.story) ? 'hasStory' : undefined}
        onClick={(event) => {
          event.stopPropagation();
          if (hasStory(item.story)) setStoryUser(item);
          else navigate(`../@${item.userid}`);
        }}
      />
    <div className='leadpartdiv' onClick={()=>{navigate(`../@${item.userid}`)}}>
          <p>
          {item.email} { item.followers > 1 &&<span><MdOutlineVerified /></span>}</p>

        {/*<button onClick={()=>{navigate(`../chat/${item.userid}`)}}>{translations.chat}</button>*/}
      {/*<button onClick={()=> dispatch(normalActions.remove_follow(item.id))}>{translations.remove}</button>*/}
    {/*<button onClick={()=>{navigate(`../@${item.userid}`)}}>{translations.vist}</button>*/}

    </div>
     <button onClick={()=> dispatch(normalActions.remove_follow(item.id))}>{translations.remove}</button>
     
  </div>)})}
</div>
    </div>
  )
}
export default LeaderPart;
